import * as React from "react";
import { Route } from "react-router-dom";
import EnsureLoggedInContainer from "./EnsureLoggedInContainer";
import EnsureContentAccessRights from "./EnsureContentAccessRights";
import EnsureSuperAdmin from "./EnsureSuperAdmin";

export const AppRoute = ({ component: Component, ...rest }) =>
    <Route {...rest} render={props =>
        <Component {...props} />
    }/>
;

export const PrivateRoute = ({ component: Component, ...rest }) =>
    <Route {...rest} render={props =>
        <EnsureLoggedInContainer>
            <Component {...props} />
        </EnsureLoggedInContainer>
    }/>
;


export const ContentManagerRoute = ({ component: Component, ...rest }) =>
    <Route {...rest} render={props =>
        <EnsureContentAccessRights>
            <Component {...props} />
        </EnsureContentAccessRights>
    }/>
;

export const SuperAdminRoute = ({ component: Component, ...rest }) =>
    <Route {...rest} render={props =>
        <EnsureLoggedInContainer>
            <EnsureSuperAdmin>
                <Component {...props} />
            </EnsureSuperAdmin>
        </EnsureLoggedInContainer>
    }/>;
